import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("circle", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}]]);
//#endregion
export { t };

//# sourceMappingURL=circle-CnwCz7ux.js.map